import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'fileType'
})
export class FileTypePipe implements PipeTransform {

    transform(value: string): string {
        if (value === 'application/pdf') {
            return 'PDF';
        } else {
            return '';
        }
    }

}
